<template>
  <section class="w3l-top-header">
    <div class="container-fluid">
      <div class="top-content-w3ls d-flex align-items-center justify-content-between">
        <div class="top-headers">
          <ul>
            <li>
              <router-link to="/help" class="d-sm-block d-none">Have any question ?</router-link>
            </li>
            <li>
              <i class="fa fa-phone"></i><a href="tel:+86 13883135370">+86 13883135370</a>
            </li>
            <li>
              <i class="fa fa-envelope"></i><a href="mailto:Thatschinese@163.com">Thatschinese@163.com</a>
            </li>
          </ul>
        </div>
        <div class="top-headers top-headers-2">
          <ul>
            <li><a href="https://www.facebook.com/ThatsChinese" target="_blank"><i class="fa fa-facebook"></i></a></li>
            <li><a href="https://www.linkedin.com/company/66298604/admin/" target="_blank"><i class="fa fa-linkedin"></i></a></li>
            <li><a href="https://www.youtube.com/channel/UCP8xEO3ieE-vw7R_KH_Nu9Q" target="_blank"><i class="fa fa-youtube"></i></a></li>
            <li><a href="https://www.instagram.com/thatschinese/" target="_blank"><i class="fa fa-instagram"></i></a></li>
            <li><a href="https://mp.weixin.qq.com/s?__biz=MzU0NDkxOTU1NA==&mid=2247494077&idx=1&sn=ddc774168d99e66b7b15071cb4c21671&chksm=fb7670d0cc01f9c6f8dd3cc35bd4c1f32141b6d35caaa8763b475ad007dbb2b512e1b0b72d30&token=1804975949&lang=zh_CN#rd" target="_blank"><i class="fa fa-weixin"></i></a></li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'TopHeader'
}
</script>

<style scoped>
.w3l-top-header {
  position: relative;
  z-index: 999;
}

#site-header {
  background: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  padding: 0.5rem 0;
}

#site-header.nav-fixed {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.navbar-brand {
  font-size: 1.5rem;
  font-weight: 600;
  color: #333;
  text-decoration: none;
}

.navbar-brand img {
  height: 40px;
  margin-right: 10px;
}

.nav-link {
  color: #333;
  font-weight: 500;
  padding: 0.5rem 1rem;
  transition: all 0.3s ease;
  text-decoration: none;
}

.nav-link:hover {
  color: #007bff;
}

.nav-item.active .nav-link {
  color: #007bff;
}

.navbar-toggler {
  border: none;
  padding: 0.5rem;
  background: transparent;
}

.navbar-toggler:focus {
  outline: none;
}

.navbar-toggler-icon {
  color: #333;
}

.navbar-toggler.collapsed .icon-expand {
  display: inline-block;
}

.navbar-toggler.collapsed .icon-close {
  display: none;
}

.navbar-toggler:not(.collapsed) .icon-expand {
  display: none;
}

.navbar-toggler:not(.collapsed) .icon-close {
  display: inline-block;
}

@media (max-width: 991px) {
  .navbar-collapse {
    background: #fff;
    padding: 1rem;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
  }

  .navbar-nav {
    margin-top: 0.5rem;
  }

  .nav-item {
    margin: 0.5rem 0;
  }
}
</style> 